import { useLocales } from '@shared/locales'
import { Form, Input } from 'antd'

export const FormNomenclaturesMailboxes = () => {
  const { t } = useLocales()

  return (
    <>
      <Form.Item
        name="from_name"
        label={t('nomenclature.from_name')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="from_email"
        label={t('nomenclature.from_email')}
        rules={[{ required: true, type: 'email' }]}
      >
        <Input />
      </Form.Item>
    </>
  )
}
